/**
 * DO NOT MANUAL MODIFY THIS FILE
 *
 * AUTO GENERATED
 */
import { Ref, SVGProps, forwardRef } from 'react';
import classNames from 'classnames';
import { ICON_CLASS } from '../../../utils/constants';
import * as Styled from '../Icon.styles';
const WindfarmSolidBase = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" fill="#404040" width="1em" height="1em" ref={ref} {...props}><path fillRule="evenodd" clipRule="evenodd" d="M13.484 1.358 8.88 7.223 1.588 8.787c-.546.117-.519.905.034.984l7.412 1.06 4.948 5.475c.374.414 1.043-.003.835-.521l-2.755-6.868 2.291-7.096c.172-.531-.524-.902-.869-.463ZM11 14.498l-2-2.213V20H7.5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h5a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5H11v-5.502Zm6.034-3.667-3.317-.474-.592-1.476.296-.916 3.458-.742 4.605-5.865c.345-.439 1.04-.068.87.463l-2.292 7.096 2.755 6.868c.208.518-.46.935-.835.521l-4.948-5.475ZM19 14.498l-2-2.213V20h-1.5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h5a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5H19v-5.502Z" /></svg>);
const WindfarmSolid = forwardRef<SVGSVGElement, SVGProps<SVGSVGElement>>(({
  className,
  ...rest
}: SVGProps<SVGSVGElement> & {
  className?: string;
}, ref) => <Styled.Icon className={classNames(ICON_CLASS, className)} as={WindfarmSolidBase} {...rest} ref={ref} />);
export default WindfarmSolid;